import BootstrapDialog from "bootstrap3-dialog"; // eslint-disable-line

export default class Bootstrap3Dialog {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    this.el
      .querySelector('button')
      .addEventListener('click', this.showDialog, false);
  }

  /* eslint-disable class-methods-use-this */
  showDialog() {
    BootstrapDialog.alert('I want banana!');
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/bootstrap_dialog.js